import { useApi, createApiHook } from "../utils/apiUtils";

const useUploadExcelForQuestionnaires = () => {
  const { apiPost } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  const uploadExcel = async (file, from_question_bank = false) => {
    if (!file) {
      return {
        data: null,
        status: null,
        errorMessage: { message: "No se proporcionó un archivo" },
      };
    }

    startLoading();

    const formData = new FormData();
    formData.append("file", file);
    formData.append("from_question_bank", from_question_bank);

    const response = await apiPost("/questionnaires/create_from_excel", "Error al subir el archivo Excel", formData, {
      "Content-Type": "multipart/form-data",
    });

    setResponse(response);

    return {
      data: response?.data,
      status: response?.status,
      errorMessage: response?.error,
    };
  };

  return { uploadExcel, data, error, loading };
};

export default useUploadExcelForQuestionnaires;
